import React, { useState } from 'react'
import FinanceDataCard from './financedatacard'
import FinanceIconPNG from '../../assets/images/FinanceIcon.png' 
import { FaRupeeSign } from 'react-icons/fa'
import FinanceDataTable from './financetable'

export default function FinanceDetailsCard({results , setOpenFinance , type}) {
    let types = {
        TCU : "totalList" ,
        PR : "pendinglist",
        AH : "accountingHealthList",
        UD: "upcomingList" ,
        OD : "overdueList"
    }
    const [typeSelected , settypeSelected ] = useState(types[type])
    
  return (
    <div>
    <div className='is-flex is-align-items-center'>
          <img
              height="3%" width="3%"
              src={FinanceIconPNG}
              // src\assets\images\bookings_png.png
              alt='vfnvf'
          />
    <h4 style={{color : "#2C358A" , fontSize : "32px" , fontWeight: '600'}}>Finance</h4>
    </div>    
    <h6 className='ml-2'><a onClick={()=>setOpenFinance(false)}>Dashboard </a>{'>'} Finance</h6> 
    {/* <FinanceDataCard results ={results}/> */}
      <div className='is-flex' style={{ gap : '0.1%' , width : "75%"}}>
              <div style={{
                  backgroundColor: "#EAF0FF", color: "#3a5aac", borderRadius: "5px", width: "20%", padding: "0.5%", textAlign: "center", boxShadow: "3px 3px 10px #635f5f", cursor: "pointer", marginLeft : '0.25%' , ...(typeSelected === types.TCU && {
                      transform: 'scale(1.1)',
                  })
              }}
              onClick={()=>settypeSelected(types.TCU)}
>
            <p className='is-size-6'>Total credit Utilized</p>
            <p className='is-size-6'><FaRupeeSign/>{results.totalCreditUtilized}</p> 
          </div>
          <div  style={{ backgroundColor : "#FFF3E8" , color : "#c89260" , borderRadius : "5px" , width : "20%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,cursor: "pointer", marginLeft : '0.25%', ...(typeSelected === types.PR && {
                      transform: 'scale(1.1)',
                  })}} onClick={()=>settypeSelected(types.PR)}>
            <p className='is-size-6'>Pending Reconciliation</p>
            <p className='is-size-6'><FaRupeeSign/>{results.pendingReconciliation}</p> 
          </div> 

        


          <div  style={{ backgroundColor : "#EBF5FF" ,color : "#629fdd", borderRadius : "5px" , width : "20%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,cursor: "pointer", marginLeft : '0.25%' , ...(typeSelected === types.UD && {
                      transform: 'scale(1.1)',
                  })}}  onClick={()=>settypeSelected(types.UD)}>
            <p className='is-size-6'>Upcoming dues</p>
            <p className='is-size-6'><FaRupeeSign/>{results.upcomingDue}</p> 
          </div> 
          <div  style={{ backgroundColor : "#FFEDED" ,color : "#d46666", borderRadius : "5px" , width : "20%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,cursor: "pointer", marginLeft : '0.25%', ...(typeSelected === types.OD && {
                      transform: 'scale(1.1)',
                  })}} onClick={()=>settypeSelected(types.OD)}>
            <p className='is-size-6'>Over dues</p>
            <p className='is-size-6'><FaRupeeSign/>{results.overdueAmount}</p> 
          </div>
          <div  style={{ backgroundColor : "#FFF3E8" , color : "#6F7C18" , borderRadius : "5px" , width : "20%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,cursor: "pointer", marginLeft : '0.25%', ...(typeSelected === types.AH && {
                      transform: 'scale(1.1)',
                  })}} onClick={()=>settypeSelected(types.AH)}>
            <p className='is-size-5'>Accounting</p>
             <p className='is-size-5'>Error</p>
            {/* <p className='is-size-6'><FaRupeeSign/>{results.acctountlist}</p>  */}
          </div> 
           </div>   
       <FinanceDataTable results={results} type ={typeSelected}></FinanceDataTable>     
      
    </div>
  )
}

// export default financedetailscard
